import dayjs from 'dayjs'
import React, { useState } from 'react'
import NumberFormat from 'react-number-format'
import { useDispatch, useSelector } from 'react-redux'
import errorAlert from '../../../assets/images/error-alert.svg'
import { WatDatePicker } from '../../../component/datePicker'
import * as paymentDetailAction from '../../../redux/actions/paymentDetail.detail.action'
import { RootReducers } from '../../../redux/reducers'

interface CreditCardProps {
  documentId: number
  form: any
  setPaymentDetailFormValue: (form: any) => void
}

const initFormErrors = {
  paymentAmount: false,
  creditCard_SignDate: false,
  creditCard_Number: false,
  creditCard_Type_dcr: false,
  creditCard_ExpDate: false,
  creditCard_ApprovalCode: false,
  creditCard_ApprovalDate: false,
  creditCard_HolderName: false,
  creditCard_HolderRelationship: false
}

const CreditCard: React.VFC<CreditCardProps> = ({
  documentId,
  form,
  setPaymentDetailFormValue
}) => {
  const dispatch = useDispatch()
  const loginState = useSelector((state: RootReducers) => state.loginReducer)
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
  const [formData, setFormData] = useState(form)
  const [formErrors, setFormErrors] = useState<any>(initFormErrors)
  const onChangeValue = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    const { name, value } = e?.target
    setFormData({
      ...formData,
      [name]: value
    })
  }
  const onChangeDate = (christDate: any, name: string) => {
    setFormData({ ...formData, [name]: christDate })
  }

  const validateAllValue = () => {
    const allCreditCardDate = [
      'creditCard_ApprovalCode',
      'creditCard_ApprovalDate',
      'creditCard_SignDate'
    ]
    const exceptionalFields = getShouldRequiredFields() ? [] : allCreditCardDate
    let allErrors = { ...initFormErrors }
    let isError = false
    Object.keys(formData).forEach(key => {
      const value = formData[key]
      if (!exceptionalFields.includes(key) && formErrors[key] !== undefined) {
        allErrors = { ...allErrors, ...{ [key]: !value } }
        if (!value) {
          isError = true
        }
      }
    })
    setFormErrors(allErrors)
    return isError
  }

  const onSubmit = () => {
    if (validateAllValue()) {
      return
    }
    setIsSubmitting(true)
    const updatedData = { ...form, ...formData }
    setPaymentDetailFormValue(updatedData)
    dispatch(paymentDetailAction.updatePaymentDetail(documentId, updatedData))
    setIsSubmitting(false)
  }
  const handleEnterKey = (e: React.KeyboardEvent<HTMLInputElement> | any) => {
    if (e.key === 'Enter') {
      e.preventDefault()
    }
  }

  const getShouldRequiredFields = () => {
    if (
      formData?.creditCard_Type_dcr === 'VSA' ||
      formData?.creditCard_Type_dcr === 'JCB' ||
      formData?.creditCard_Type_dcr === 'MAS'
    ) {
      return false
    }
    return true
  }

  const getCreditCardValue = () => {
    if (loginState.account?.agentInfo.isAO || loginState.account?.agentInfo.isBranchStaff) {
      return formData?.creditCard_Number_data
    }

    return formData?.creditCard_Number
  }

  console.log('formData', formData)

  return (
    <div className="container-inf">
      <div className="form-content">
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">จำนวนเงิน</span>
            <NumberFormat
              allowNegative={false}
              thousandSeparator={true}
              prefix=""
              name="paymentAmount"
              className={`amount-input ${formErrors?.paymentAmount && 'error-border-validate'}`}
              inputMode="decimal"
              decimalScale={2}
              autoComplete="off"
              disabled={true}
              value={formData?.paymentAmount}
              onChange={onChangeValue}
              onKeyPress={handleEnterKey}
            />
            {formErrors?.paymentAmount && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">เลขที่บัตร</span>
            <div className="amount-input" style={{ display: 'flex', alignItems: 'center' }}>
              {getCreditCardValue()}
            </div>
            {formErrors.creditCard_Number && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">ประเภทบัตร</span>
            <select
              className={`select-input ${
                formErrors.creditCard_Type_dcr && 'error-border-validate'
              }`}
              name="creditCard_Type_dcr"
              placeholder="ประเภทบัตร"
              //disabled={true}
              value={formData?.creditCard_Type_dcr}
              onChange={onChangeValue}
            >
              <option value="BPT">BPT (Pay-lite 0%)</option>
              <option value="EDC">EDC</option>
              <option value="KPT">KPT</option>
              <option value="MAS">Master</option>
              <option value="SPT">SPT</option>
              <option value="JCB">JCB</option>
              <option value="VSA">VISA</option>
            </select>
            {formErrors.creditCard_Type_dcr && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณาเลือกประเภทบัตร
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">วันที่หมดอายุ</span>
            <NumberFormat
              className={`amount-input ${formErrors.creditCard_ExpDate && 'error-border-validate'}`}
              type="text"
              name="creditCard_ExpDate"
              format="##/##"
              disabled={true}
              placeholder="MM/YY"
              autoComplete="off"
              value={formData?.creditCard_ExpDate}
              onChange={onChangeValue}
            />
            {formErrors?.creditCard_ExpDate && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                {formErrors.creditCard_ExpDate}
              </div>
            )}
          </label>
        </div>
        <div className={getShouldRequiredFields() ? 'required' : ''}>
          <span className="amount-text">ลงวันที่</span>
          <WatDatePicker
            className={`amount-input ${formErrors.creditCard_SignDate && 'error-border-validate'}`}
            name="creditCard_SignDate"
            dateFormat={'yyyy-MM-dd'}
            displayFormat={'DD/MM/YYYY'}
            clearable={false}
            minDate={dayjs().add(-2, 'year')}
            maxDate={dayjs().add(5, 'year')}
            disabled={false}
            readOnly={false}
            yearBoundary={99}
            onChange={(chrisDate: any, buddhistDate: any) => {
              onChangeDate(chrisDate, 'creditCard_SignDate')
            }}
            value={formData?.creditCard_SignDate}
          />
          {formErrors.creditCard_SignDate && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
        <div className={getShouldRequiredFields() ? 'required' : ''}>
          <span className="amount-text">วันที่อนุมัติ</span>
          <WatDatePicker
            className={`amount-input 
            ${formErrors?.creditCard_ApprovalDate && 'error-border-validate'}`}
            name="creditCard_ApprovalDate"
            dateFormat={'yyyy-MM-dd'}
            displayFormat={'DD/MM/YYYY'}
            clearable={false}
            minDate={dayjs().add(-2, 'year')}
            maxDate={dayjs().add(5, 'year')}
            disabled={false}
            readOnly={false}
            yearBoundary={99}
            onChange={(chrisDate: any, buddhistDate: any) => {
              onChangeDate(chrisDate, 'creditCard_ApprovalDate')
            }}
            value={formData?.creditCard_ApprovalDate}
          />
          {formErrors.creditCard_ApprovalDate && (
            <div className="error-text-validate">
              <img src={errorAlert} alt="ErrorAlert" />
              กรุณากรอกข้อมูล
            </div>
          )}
        </div>
        <div className={getShouldRequiredFields() ? 'required' : ''}>
          <label className="group-label-input">
            <span className="amount-text">รหัสอนุมัติ</span>
            <input
              className={`amount-input 
              ${formErrors?.creditCard_ApprovalCode && 'error-border-validate'}`}
              type="text"
              name="creditCard_ApprovalCode"
              autoComplete="off"
              disabled={false}
              value={formData?.creditCard_ApprovalCode}
              onChange={onChangeValue}
              onKeyPress={handleEnterKey}
              maxLength={6}
            />
            {formErrors?.creditCard_ApprovalCode && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">ชื่อเจ้าของบัตรเครดิต</span>
            <input
              className={`amount-input 
              ${formErrors.creditCard_HolderName && 'error-border-validate'}`}
              type="text"
              name="creditCard_HolderName"
              autoComplete="off"
              disabled={true}
              value={formData?.creditCard_HolderName}
              onChange={onChangeValue}
              maxLength={30}
            />
            {formErrors.creditCard_HolderName && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <div className="required">
          <label className="group-label-input">
            <span className="amount-text">
              เจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย
            </span>
            <select
              className={`select-input 
              ${formErrors?.creditCard_HolderRelationship && 'error-border-validate'}`}
              name="creditCard_HolderRelationship"
              placeholder="เจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย"
              disabled
              value={formData?.creditCard_HolderRelationship}
              onChange={onChangeValue}
            >
              <option value="027">ตนเอง </option>
              <option value="001">บิดา </option>
              <option value="002">มารดา </option>
              <option value="003">คู่สมรส </option>
              <option value="004">บุตร </option>
              <option value="009">บุตรบุญธรรมตามกฎหมาย </option>
              <option value="020">บิดาบุญธรรม </option>
              <option value="021">มารดาบุญธรรม</option>
              <option value="005">ปู่ </option>
              <option value="006">ย่า </option>
              <option value="007">ตา </option>
              <option value="008">ยาย </option>
              <option value="022">พี่ร่วมบิดาและมารดาเดียวกัน </option>
              <option value="023">น้องร่วมบิดาและมารดาเดียวกัน</option>
              <option value="024">พี่ร่วมบิดาหรือมารดาเดียวกัน </option>
              <option value="025">น้องร่วมบิดาหรือมารดาเดียวกัน</option>
              <option value="017">พี่ </option>
              <option value="018">น้อง </option>
              <option value="014">หลาน</option>
              <option value="010">ลุง </option>
              <option value="011">ป้า </option>
              <option value="012">น้า </option>
              <option value="013">อา </option>
              <option value="026">บริษัท</option>
              <option value="028">กองมรดก </option>
              <option value="029">คู่ชีวิต</option>
              <option value="030">ลูกพี่ลูกน้อง</option>
            </select>
            {formErrors.creditCard_HolderName && (
              <div className="error-text-validate">
                <img src={errorAlert} alt="ErrorAlert" />
                กรุณากรอกข้อมูล
              </div>
            )}
          </label>
        </div>
        <span className="amount-text">หมายเหตุ</span>
        <input
          className={`amount-input`}
          type="text"
          name="remarkMoneyType"
          autoComplete="off"
          value={formData?.remarkMoneyType}
          onChange={onChangeValue}
          onKeyPress={handleEnterKey}
        />
        <div className="button-container">
          <button
            className="cancel-button"
            onClick={() => {
              setPaymentDetailFormValue('')
            }}
          >
            ยกเลิก
          </button>
          <button className="confirm-paid-button" onClick={onSubmit} disabled={isSubmitting}>
            {isSubmitting ? 'กำลังบันทึกข้อมูล...' : 'ตกลง'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default CreditCard
